import { useContext } from 'react'

import { type ViewLikesContextAction } from 'context/ViewLikesContext/dispatchTypes'
import { type IViewLikesContextState } from 'context/ViewLikesContext/types'
import { ViewLikesContext } from 'context/ViewLikesContext/ViewLikesContext'

export const useViewLikesContext = () => {
    const context = useContext(ViewLikesContext)

    if (context === undefined) {
        throw new Error(
            'useViewLikesContext must be used within a ViewLikesContextProvider'
        )
    }

    return context as {
        state: IViewLikesContextState
        dispatch: React.Dispatch<ViewLikesContextAction>
    }
}
